let obj = {};
// 保险期限
obj.guarantPre = [
  {
    key: '1',
    value: '1个月'
  },
  {
    key: '3',
    value: '3个月'
  },
  {
    key: '6',
    value: '6个月'
  },
  {
    key: '12',
    value: '12个月'
  }
];
// 企业证件类型
obj.companyIdTypeOptions = [
  {
    value: '03',
    name: '统一社会信用代码'
  }
];
obj.companyPropertyList = [
  {
    value: '01',
    text: '国家机关'
  },
  {
    value: '02',
    text: '国有事业单位'
  },
  {
    value: '03',
    text: '国有企业'
  },
  {
    value: '06',
    text: '上市公司'
  },
  {
    value: '99',
    text: '其它'
  }
];
obj.cunxuTimeList = [
  {
    value: '2',
    text: '3年以下'
  },
  {
    value: '3',
    text: '3年及以上'
  }
];
obj.KZSCOptions = [
  {
    value: -1,
    name: '不附加'
  },
  {
    value: 1,
    name: '附加'
  }
];
obj.GSPFBZOptions = [
  {
    value: '0',
    name: '不附加'
  },
  {
    value: '1',
    name: '附加'
  }
];
obj.WGFptions = [
  {
    value: '-1',
    name: '不附加'
  },
  {
    value: 50,
    name: '50元/天'
  },
  {
    value: 100,
    name: '100元/天'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  },
  {
    value: '6',
    name: '6类'
  }
];
obj.IdTypeOptions = [
  {
    value: '1',
    name: '身份证'
  }
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.plansValues = [
  {
    value: -1,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  }
];
obj.columns = [
  //表头
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "证件类型",
    dataIndex: "idType",
    key: "idType",
    scopedSlots: { customRender: "idType" },
  },
  {
    title: "证件号码",
    dataIndex: "idNumber",
  },
  {
    title: "出生日期",
    dataIndex: "birthDate",
  },
  {
    title: "性别",
    dataIndex: "gender",
    key: "gender",
    scopedSlots: { customRender: "gender" },
  },
  {
    title: "职业代码",
    dataIndex: "occupationCode",
  },
  {
    title: "职业名称",
    dataIndex: "occupationName",
  },
  {
    title: "职业类别",
    dataIndex: "occulevel",
    key: "occulevel",
    scopedSlots: { customRender: "occulevel" },
  },
];
export default { ...obj };
